import { createResourceCollection } from '@/request'
import { VehicleActiveChargeSettings } from '@/types/activeChargeSettings'

/**
 * Client for `GET /api/active_charge_settings/vehicle/<vehicle_id>/`.
 *
 * The response body has no `id` field, but does have `vehicle_id` — `computedId`
 * derives a stable cache key from it.
 */
export const vehicleActiveChargeSettingsCollection = createResourceCollection<
  VehicleActiveChargeSettings & { id: string }
>({
  name: 'vehicleActiveChargeSettings',
  selector: (state) => state.vehicleActiveChargeSettings,
  computedId: (data) =>
    `vehicleActiveChargeSettings:vehicle_id:${data.vehicle_id}`,
  apiConfig: {
    path: 'active_charge_settings/vehicle',
  },
})

export default vehicleActiveChargeSettingsCollection.slice.reducer
